<script lang="ts">
    import "../app.postcss";

    // import { AppShell, AppBar } from "@skeletonlabs/skeleton";

    import { computePosition, autoUpdate, offset, shift, flip, arrow } from "@floating-ui/dom";
    import { storePopup } from "@skeletonlabs/skeleton";
    storePopup.set({ computePosition, autoUpdate, shift, offset, flip, arrow });
    import Header from "$lib/Components/Header.svelte";
    import Footer from "$lib/Components/Footer.svelte";
    import { onMount, afterUpdate, beforeUpdate } from "svelte";
    import og_image from "$lib/assets/images/og-image.png";
    import Analtyics from "$lib/Components/Analtyics.svelte";

    onMount(() => {
        /* eslint-enable */
        window.scrollTo(0, 0);
        window.onload = () => {
            window.scrollTo(0, 0);
        };
    });
</script>

<svelte:head>
    <link rel="preconnect" href="https://fonts.googleapis.com" />
    <link rel="preconnect" href="https://fonts.gstatic.com" crossorigin="true" />
    <link href="https://fonts.googleapis.com/css2?family=Inter:wght@300..700&display=swap" rel="stylesheet" />
    <meta property="og:image" content={og_image} />
</svelte:head>

<!-- Google analytics -->
<Analtyics />
<!-- Google analytics -->

<div class="flex flex-col min-h-screen overflow-auto">
    <Header />
    <main class="flex-1">
        <slot />
    </main>
    <Footer />
    <!-- Google Tag Manager (noscript) -->
    <noscript><iframe title="Google Tag Manager Noscript" src="https://www.googletagmanager.com/ns.html?id=GTM-5XQZHXC3" height="0" width="0" style="display:none;visibility:hidden"></iframe></noscript>
    <!-- End Google Tag Manager (noscript) -->
</div>

<style>
    :global(body) {
        font-family: "Inter", sans-serif;
        overflow-y: scroll;
        font-weight: 300;
    }
    :global(h1) {
        font-family: "Inter", sans-serif;
        font-weight: 700;
    }
    :global(h2) {
        font-family: "Inter", sans-serif;
        font-weight: 700;
    }
</style>
